var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"outlined":_vm.outlined,"flat":_vm.flat}},[_c('personnel-record-detail-card-content',{attrs:{"member":_vm.member,"small":_vm.small,"hideDividers":_vm.hideDividers,"hideAssignments":_vm.hideAssignments,"hideSkills":_vm.hideSkills}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }